/**
 * Catálogo de anexos do PCMSO e do PGR (#520). Não há rota de leitura por id: a edição acha o
 * anexo na lista, como no catálogo de vacinas.
 */
import apiClient from './apiClient';
import type { DocumentAttachment, DocumentAttachmentPayload } from '../types/documentAttachment';

class DocumentAttachmentService {
  private baseUrl = '/document-attachments';

  async getAll(): Promise<DocumentAttachment[]> {
    const response = await apiClient.get<DocumentAttachment[]>(this.baseUrl);
    return response.data ?? [];
  }

  async create(data: DocumentAttachmentPayload): Promise<DocumentAttachment | undefined> {
    const response = await apiClient.post<DocumentAttachment>(this.baseUrl, data);
    return response.data;
  }

  async update(id: string, data: DocumentAttachmentPayload): Promise<DocumentAttachment | undefined> {
    const response = await apiClient.put<DocumentAttachment>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }
}

export const documentAttachmentService = new DocumentAttachmentService();
export default documentAttachmentService;
